import React, { Component } from "react";
import { Route } from "react-router-dom";
import { Button, Row, Card, CardBody, CardTitle, Table } from "reactstrap";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";

import { Colxx } from "../../components/common/CustomBootstrap";
import PassengerSelectWithBatch from "../../components/PassengerSelectWithBatch";
import { authApiAccessCheck } from "../../redux/actions";
import { PassengerChangesGetByPassengers } from "../../api-tasks/passenger";
import DateRangePicker from "../../components/DateRangePicker";
import LocationName from "../../components/LocationName";
import PassengerClusters from "../../data-const/passenger-types";

import {
  AppHelperDateAndTimeToString,
  AppHelperDateToDBString,
} from "../../helpers/AppHelper";
import moment from "moment";
import IntlMessages from "../../helpers/IntlMessages";
import AppLocale from "../../lang";
import { createIntl } from "react-intl";

const pagingLimit = -1;

const headers = [
  { label: "Passenger", key: "passengerName" },
  { label: "Vehicle", key: "vehicleName" },
  { label: "Time", key: "time" },
  { label: "Place", key: "place" },
  { label: "Geo", key: "geo" },
  { label: "Cluster", key: "clusterText" },
];

class PassengerChanges extends Component {
  constructor() {
    super();
    this.state = {
      selectedPassengers: [],
      loading: false,
      allRows: [],
      totalCount: 0,
      touched: false,
      limit: pagingLimit,
      skip: 0,
      fileName: "Ctraac - alerts.csv",
    };
  }

  componentWillUnmount() {}

  componentDidMount() {}

  handleOnSelectedPassengersChange = (selectedPassengers) => {
    this.setState({ selectedPassengers });

    this.setState({
      selectedPassengers,
      allRows: [],
      limit: pagingLimit,
      skip: 0,
    });

    setTimeout(() => {
      this.onDateRangeGo(this.state.limit, this.state.skip);
    }, 10);
  };

  onDateRangeGo = (limit, skip) => {
    if (!this.state.selectedPassengers.length) {
      return;
    }

    const user = this.props.user;
    const startTime = AppHelperDateToDBString(this.state.startTime.toDate());
    const endTime = AppHelperDateToDBString(this.state.endTime.toDate());

    const passengerIds = this.state.selectedPassengers.map((el) => {
      return el.key;
    });

    this.setState({ loading: true });

    PassengerChangesGetByPassengers(
      user.userToken,
      passengerIds,
      startTime,
      endTime,
      limit,
      skip
    ).then((response) => {
      this.setState({
        loading: false,
        limit,
        skip,
        fileName: `Ctraac - Passenger Changes, ${this.state.startTime.format(
          "YYY-MM-DD hh:mm A"
        )} to ${this.state.endTime.format("YYY-MM-DD hh:mm A")}.csv`,
      });

      if (response && Array.isArray(response.rows)) {
        const a = response.rows.map((x) => {
          return {
            ...x,
            time: AppHelperDateAndTimeToString(x.event_time),
            driverName: this.findDriverName(x),
            vehicleName: this.findVehicleName(x),
            passengerName: this.findPassengerName(x),
            clusterText: this.findClusterName(x),
          };
        });

        this.setState({
          allRows: a,
          totalCount: response.count,
          touched: true,
        });
      }
    });
  };

  handleChangeDateRange = (startTime, endTime) => {
    this.setState({
      startTime,
      endTime,
      limit: pagingLimit,
      skip: 0,
      allRows: [],
    });
    if (this.state.selectedPassengers.length) {
      setTimeout(() => {
        this.onDateRangeGo(this.state.limit, this.state.skip);
      }, 10);
    }
  };

  handlePagingChange = (limit, skip) => {
    this.onDateRangeGo(limit, skip);
  };

  formatedPushButton = (itemObject, buttonText, path) => {
    const ButtonLive = () => (
      <Route
        render={({ history }) => (
          <Button
            size="xs"
            color="link"
            onClick={() => {
              history.push({
                pathname: path,
                state: { itemObject: itemObject },
              });
            }}
          >
            {buttonText}
          </Button>
        )}
      />
    );
    return <ButtonLive />;
  };

  findDriverName = (item) => {
    const ignition = item || {};
    if (ignition.driver_id && ignition.driver_id > 0) {
      if (this.props.driversAll && this.props.driversAll.length) {
        const selectedDriver = this.props.driversAll.filter(function (value) {
          return value.autoid === ignition.driver_id;
        });

        if (selectedDriver && selectedDriver.length) {
          return `${selectedDriver[0].driver_name}-${selectedDriver[0].employee_code}`;
        }
      }
    }
    return "";
  };

  findVehicleName = (item) => {
    const ignition = item || {};
    if (ignition.vehicle_id && ignition.vehicle_id > 0) {
      if (this.props.vehiclesAll && this.props.vehiclesAll.length) {
        const foo = this.props.vehiclesAll.filter(function (value) {
          return value.autoid === ignition.vehicle_id;
        });

        if (foo && foo.length) {
          return `${foo[0].plate_number} ${foo[0].fleet_number} ${foo[0].model} ${foo[0].typeText}`;
        }
      }
    }
    return "";
  };

  findPassengerName = (item) => {
    const ignition = item || {};
    if (ignition.passenger_id && ignition.passenger_id > 0) {
      if (this.props.passengersAll && this.props.passengersAll.length) {
        const foo = this.props.passengersAll.filter(function (value) {
          return value.autoid === ignition.passenger_id;
        });

        if (foo && foo.length) {
          return `${foo[0].passenger_name} - ${foo[0].employee_code}`;
        }
      }
    }
    return "";
  };

  findClusterName = (item) => {
    const ignition = item || {};
    if (ignition.passenger_id && ignition.passenger_id > 0) {
      if (this.props.passengersAll && this.props.passengersAll.length) {
        const foo = this.props.passengersAll.filter(function (value) {
          return value.autoid === ignition.passenger_id;
        });

        if (foo && foo.length) {
          // return `${foo[0].passenger_name} - ${foo[0].employee_code}`;
          return PassengerClusters.filter((d) => d.id === foo[0].cluster)[0]
            .title;
        }
      }
    }
    return "";
  };

  render() {
    const currentAppLocale = AppLocale[this.props.locale];
    // Create the `intl` object
    const intl = createIntl({
      // Locale of the application
      locale: currentAppLocale.locale,
      // Locale of the fallback defaultMessage
      defaultLocale: "en",
      messages: currentAppLocale.messages,
    });
    window.localsss = intl;
    return (
      <React.Fragment>
        <Row className="mb-1">
          <Colxx xxs="12">
            <Card>
              <CardBody className={this.state.loading ? "wait" : ""}>
                <Row className="mb-1">
                  <Colxx xxs="12">
                    <PassengerSelectWithBatch
                      classNamePrefix="repo-sel"
                      onChange={this.handleOnSelectedPassengersChange}
                    />
                  </Colxx>
                </Row>

                <Row>
                  <Colxx xl="5" lg="5" md="6" sm="12">
                    <DateRangePicker
                      onChange={this.handleChangeDateRange}
                      suggestions="months"
                      startTime={moment().startOf("month")}
                    />
                  </Colxx>
                  <Colxx xxs="2">
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() =>
                        this.onDateRangeGo(this.state.limit, this.state.skip)
                      }
                    >
                      {this.state.loading ? (
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                      ) : (
                        <IntlMessages id="common.refresh" />
                      )}
                    </Button>
                  </Colxx>
                </Row>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row>
          <Colxx xxs="12">
            <Card>
              <CardBody>
                {this.state.selectedPassengers.length && this.state.touched ? (
                  <CardTitle>
                    {intl.formatMessage({
                        id: "report.passenger-alerts",
                      })} :{" from "}
                    {AppHelperDateAndTimeToString(
                      this.state.startTime.toDate()
                    )}
                    {" to "}
                    {AppHelperDateAndTimeToString(this.state.endTime.toDate())}
                  </CardTitle>
                ) : (
                  <CardTitle>  <IntlMessages id="report.try-search" /> </CardTitle>
                )}

                {this.state.touched && !this.state.totalCount ? (
                  <p>{+" " +
                  intl.formatMessage({
                    id: "report.nothing-show",
                  })}</p>
                ) : (
                  ""
                )}
                <div className="card-body-min-height">
                  <div className="float-right">
                    <CSVLink
                      headers={headers}
                      filename={this.state.fileName}
                      data={this.state.allRows}
                    >
                      <Button
                        title={this.state.fileName}
                        size="xs"
                        outline
                        color="dark"
                      >
                        <IntlMessages id="common.download" />
                      </Button>
                    </CSVLink>
                  </div>
                  {this.state.allRows.length + " " +
                    intl.formatMessage({
                      id: "report.records",
                    })}

                  <Table responsive hover bordered striped>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th><IntlMessages id="report.passenger" /></th>
                        <th><IntlMessages id="report.vehicle" /></th>
                        <th><IntlMessages id="report.place" /></th>
                        <th><IntlMessages id="report.cluster" /></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.allRows.map((item, i) => (
                        <tr key={this.state.skip + i + 1}>
                          <th scope="row">{this.state.skip + i + 1}</th>

                          <td>{item.passengerName}</td>
                          <td>{item.vehicleName}</td>
                          <td>
                            {item.time}
                            <br />
                            <LocationName
                              place={item.place}
                              geo={item.geo}
                              objectItem={item}
                              showGoogle
                            />
                          </td>
                          <td>{item.clusterText}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  vehicles,
  authUser,
  drivers,
  passengers,
  settings,
}) => {
  const { all } = vehicles;
  const { user } = authUser;
  const { items } = drivers;
  const { locale } = settings;
  const passengersAll = passengers.items || [];
  return { vehiclesAll: all, user, driversAll: items, passengersAll,locale };
};

export default connect(mapStateToProps, { authApiAccessCheck })(
  PassengerChanges
);
